// src/components/Signup.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; // Use axios directly as 'api' might not be universally defined
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import eye icons

const API_BASE = process.env.REACT_APP_API_URL; // Ensure this is correctly configured in your .env

const Signup = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [errors, setErrors] = useState([]);
  const [showPassword, setShowPassword] = useState(false); // New state for password visibility
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
    setErrors([]); // Clear errors on input change
  };

  const handleSubmit = async e => {
    e.preventDefault(); // Prevent default form submission
    setError('');
    setErrors([]); // Clear previous errors

    try {
      await axios.post(`${API_BASE}/api/auth/signup`, form);
      // Replaced alert with navigation to login page with a success state
      navigate('/login', { state: { signupSuccess: true } });
    } catch (err) {
      const res = err.response;
      console.error('Signup failed (frontend catch block):', res?.data || err.message, res?.status);
      if (res?.data?.errors) {
        // Handle validation errors from express-validator
        setErrors(res.data.errors);
      } else {
        // Handle general error messages
        setError(res?.data?.message || 'Signup failed');
      }
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-cyan-600 to-blue-800 font-inter text-white">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-md bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white/20">
        <h2 className="text-3xl font-bold mb-6 text-center text-white">Sign Up</h2>

        {error && <p className="text-red-300 text-center">{error}</p>}
        {errors.length > 0 && (
          <ul className="text-red-300 text-sm list-disc pl-5 space-y-1">
            {errors.map((err, idx) => (
              <li key={idx}>{err.msg}</li>
            ))}
          </ul>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-white text-sm font-bold mb-2" htmlFor="name">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your name"
              autoComplete="name"
              value={form.name}
              onChange={handleChange}
              required
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white/20 border-white/30 placeholder-gray-300"
            />
          </div>

          <div>
            <label className="block text-white text-sm font-bold mb-2" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={form.email}
              onChange={handleChange}
              required
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white/20 border-white/30 placeholder-gray-300"
            />
          </div>

          <div className="relative">
            <label className="block text-white text-sm font-bold mb-2" htmlFor="password">
              Password
            </label>
            <input
              type={showPassword ? 'text' : 'password'} // Toggle type based on state
              id="password"
              name="password"
              placeholder="Enter your password"
              autoComplete="new-password" // Use 'new-password' for signup forms
              value={form.password}
              onChange={handleChange}
              required
              className="shadow appearance-none border rounded w-full py-3 px-4 pr-10 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white/20 border-white/30 placeholder-gray-300"
            />
            <button
              type="button" // Important: type="button" to prevent form submission
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 pr-3 flex items-center pt-8 text-gray-300 hover:text-white focus:outline-none"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button
            type="submit"
            className="bg-white text-cyan-700 font-bold py-2 px-4 rounded-full w-full hover:bg-gray-200 transition duration-300"
          >
            Sign Up
          </button>
        </form>
      </div>
    </div>
  );
};

export default Signup;
